import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { EventStreamLinkedService } from '../linkedservice/event-stream.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';

@Metamodel.model({
    name: ModelConstants.eventStreamDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.EventStream_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.EventStream_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: EventStreamLinkedService.MODEL
        }
    }
})
export class EventStreamDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
